export const palletListConvertor = palletList => {
  return palletList.map(item => ({
    ...item,
    palletID: item?.palletID,
    closed: item?.closed,
    dimensions: {
      length: Number(item?.dimensions?.length) || 0,
      width: Number(item?.dimensions?.width) || 0,
      height: Number(item?.dimensions?.height) || 0,
    },
    totalNumberOfPeices: Number(item?.totalNumberOfPeices) || 0,
    weight: Number(item?.weight) || 0,
  }));
};
